export const LEVEL_INFO = "/level-info";
export const GAME = "/game";
export const GAMEOVER = "/game-over";
export const GAMEINTRO = "/game-intro";